/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable redux-saga/no-unhandled-errors */
import dayjs from 'dayjs';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { balanceRequest } from 'src/services/userApi';
import { RootState } from 'src/types/store-types';
import { autoSignInRequest, signInRequest, updatePersonalInfo } from '../../services/authorizationApi';
import { IReqPayloadStructure } from '../../types/store-types';
import { openAuthModal, setForgotText } from '../auth-modal/actions';
import { FIRST_DEPOSIT_TO_BONUS_SUCCESS } from '../bonus-messaging/types';
import { openDialog } from '../dialog/actions';
import { EnumDialogsKeys } from '../dialog/types';
import { setBalance, setError, setLogout, signIn, userUpdateLoading } from './actions';
import { APP_BALANCE_REQ, LOGOUT, USER_AUTO_SIGN_IN_REQ, USER_SET_UPDATE_USER, USER_SIGN_IN_REQ } from './types';

export function* signInSaga({ payload }: any): any {
  const { onSuccessCb, onFailCb, data } = payload;
  try {
    yield put(signIn.load(true));
    const resp: IReqPayloadStructure | any = yield call(signInRequest, data);

    yield put(setError({}));

    if (resp.success) {
      if (resp.result.isVerification) {
        yield put(
          openDialog({
            dialogType: EnumDialogsKeys.PLAYER_2_STEP,
            dialogProps: { data: { username: data.username, onSuccessCb } },
          })
        );
      } else {
        const now = dayjs();
        const storedDate = now.add(resp.result.exp, 'seconds').valueOf();

        yield put(setBalance.success(resp.result?.wallets));

        if (resp.result?.authClientUrl) {
          yield put(
            openDialog({
              dialogType: EnumDialogsKeys.DINHU_ANALIZER,
              dialogProps: { data: resp?.result?.authClientUrl },
            })
          );
        }

        if (resp.result?.token && resp.result?.id && resp.result?.username) {
          window.__gdlib?.login(resp.result?.token);
        }
        const user = {
          ...resp.result,
          personalInfo: {
            ...resp.result.personalInfo,
            emailVerified: Boolean(resp.result.personalInfo.emailVerified),
            phoneVerified: Boolean(resp.result.personalInfo.phoneVerified),
          },
        };
        localStorage.setItem('wallets', JSON.stringify(resp.result?.wallets));
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('sessionId', Date.now().toString());
        localStorage.setItem('storedDate', String(storedDate));
        window.__gdlib?.login(resp.result?.token);
        sessionStorage.removeItem('signUpBonusCode');
        sessionStorage.removeItem('signInBonusCode');

        yield put(signIn.success({ ...user, storedDate }));
        yield put(signIn.load(false));

        if (onSuccessCb) {
          onSuccessCb();
        }
      }
    } else {
      if (resp.message.key === 'terms_not_accepted') {
        yield put(
          openDialog({
            dialogType: EnumDialogsKeys.TERMS_NOT_ACCEPTED,
            dialogProps: {
              data,
            },
          })
        );
      }
      if (resp.message.key === 'forcedResetPassword') {
        yield put(setForgotText('resetIncorectPassword'));
        yield put(openAuthModal('forgot'));
      }
      if (resp.message.key === 'account_disabled') {
        yield put(setError({ error: 'signIn_error_account_disabled' }));
        const params = resp.message?.params;
        if (!Array.isArray(params)) return;
        let data = null;
        if (params.includes('PROGRAMA_SOCIAL')) {
          data = {};
        }
        if (params.includes('AUTOEXCLUSAO_CENTRALIZADA')) {
          data = { centralIzada: true };
        }
        if (data !== null) {
          yield put(
            openDialog({
              dialogType: EnumDialogsKeys.SOCIAL_PROGRAM_POPUP,
              dialogProps: { data },
            })
          );
        }
      } else {
        yield put(setError({ error: 'signIn_error_text' + `_${data.loginKey}` }));
      }
      yield put(signIn.load(false));

      if (onFailCb) {
        onFailCb();
      }
    }
  } catch (error: any) {
    if (onFailCb) {
      onFailCb();
    }
  }
}

export function* updatePersonalInfoReq({ payload }: any): any {
  yield put(userUpdateLoading(true));
  const res = yield call(updatePersonalInfo, payload);
  if (res.success) {
    const { user } = yield select((state: RootState) => state.user);
    const newUser: any = {
      ...user,
      personalInfo: {
        ...user.personalInfo,
        ...payload,
      },
    };
    if (payload.email) {
      newUser.personalInfo.emailVerified = false;
    }
    if (payload.phoneNumber) {
      newUser.personalInfo.phoneVerified = false;
    }
    localStorage.setItem('user', JSON.stringify(newUser));
    yield put(signIn.success(newUser));
  }
  yield put(userUpdateLoading(false));
}

export function* autoSignInSaga({ payload }: any): any {
  const { onSuccessCb, onFailCb, data } = payload;
  if (!payload?.data?.token) {
    return;
  }
  try {
    yield put(signIn.load(true));
    const resp: IReqPayloadStructure = yield call(autoSignInRequest, data);
    (window as any).autoCloseWebsite = true;
    if (resp.success) {
      const now = dayjs();
      const storedDate = now.add(resp.result.exp, 'seconds').valueOf();

      yield put(setBalance.success(resp.result?.wallets));

      if (resp.result?.token && resp.result?.id && resp.result?.username) {
        window.__gdlib?.login(resp.result?.token);
      }
      localStorage.setItem('user', JSON.stringify({ ...resp.result }));
      localStorage.setItem('wallets', JSON.stringify(resp.result?.wallets));
      localStorage.setItem('sessionId', Date.now().toString());
      localStorage.setItem('storedDate', String(storedDate));
      yield put(signIn.success({ ...resp.result, storedDate }));
      yield put(signIn.load(false));

      if (onSuccessCb) {
        onSuccessCb();
      }
    } else {
      console.error('Failed to autoSignInSaga ' + data);
      window.alert('Failed to autoSingInSaga with token: ' + data.token);
      yield put(setError({ error: 'signIn_error_text_username' }));
      yield signOutSaga();
      yield put(signIn.load(false));

      if (onFailCb) {
        onFailCb();
      }
    }
  } catch (error: any) {
    if (onFailCb) {
      onFailCb();
    }
  }
}

export function* signOutSaga(d?: any): any {
  // Send postmessage for GoS
  const tournametIframe: any = document.getElementById('tournament');

  // Send postmessage for FunBonuss
  const funMissionIframe: any = document.getElementById('funMissionIframe');

  // close poker popup
  if ((window as any)?.externalPopupLink) {
    (window as any)?.externalPopupLink?.close();
  }

  if (funMissionIframe) {
    yield funMissionIframe.contentWindow.postMessage({ type: 'logout' }, '*');
  }

  if (tournametIframe) {
    yield tournametIframe.contentWindow.postMessage({ type: 'logout' }, '*');
  }
  yield localStorage.removeItem('storedDate');
  yield localStorage.removeItem('user');
  yield localStorage.removeItem('token');
  yield localStorage.getItem('token-expire') && localStorage.removeItem('token-expire');
  yield localStorage.removeItem('wallets');
  yield localStorage.removeItem('resumeGameId');
  yield localStorage.removeItem('referralLinks');
  yield localStorage.removeItem('sessionId');
  if (d?.payload && d?.payload.onSuccessCb) {
    d.payload.onSuccessCb();
  }
}

function* getBalance(): any {
  try {
    const user = yield select((store: RootState) => store.user.user);
    if (user) {
      const response = yield call(balanceRequest);
      const { wallets } = response.result;

      yield put(setBalance.success(wallets));
    } else {
      console.log('Wrong getBalance => user not found');
    }
  } catch (e: any) {
    //TO DO show some popup for inform abour force logout
    if (e?.response?.data?.errorKey === 'multiLogin') {
      yield put(setLogout());
    }
    yield put(setBalance.fail());
  }
}

export function* watchAutoSignIn(): any {
  yield takeLatest(USER_AUTO_SIGN_IN_REQ, autoSignInSaga);
}

export function* watchUser(): any {
  yield takeLatest(USER_SIGN_IN_REQ, signInSaga);
  yield takeLatest(LOGOUT, signOutSaga);
  yield takeLatest(APP_BALANCE_REQ, getBalance);
  yield takeLatest(FIRST_DEPOSIT_TO_BONUS_SUCCESS, getBalance);
  yield takeLatest(USER_SET_UPDATE_USER, updatePersonalInfoReq);
}
